import { Action } from 'redux';
import { RootState } from '.';
import { useSelector } from 'react-redux';

export const THEME = 'THEME';

export type ThemeMode = 'light' | 'dark' | 'dark2';

function normalizeThemeMode(mode: string | null | undefined): ThemeMode {
    return mode === 'dark' || mode === 'dark2' ? mode : 'light';
}

const initialState: ThemeMode = normalizeThemeMode(localStorage.getItem('theme'));

export interface ThemeAction extends Action {
    type: typeof THEME;
    payload: ThemeMode;
}

export function changeThemeAction(theme: ThemeMode): ThemeAction {
    localStorage.setItem('theme', theme);
    return {
        type: THEME,
        payload: theme
    };
}

export function themeReducer(state = initialState, action: ThemeAction): ThemeMode {
    switch (action.type) {
        case THEME:
            return action.payload;
        default:
            return state;
    }
}

export function useCbxTheme(): ThemeMode {
    const themeLocalStorage = localStorage.getItem('theme');
    const themeRedux = useSelector((root: RootState) => root.theme);
    return normalizeThemeMode(themeLocalStorage || themeRedux);
}